import { render } from "./HomeIcon.vue?vue&type=template&id=670349a5&scoped=true"
import script from "./HomeIcon.vue?vue&type=script&lang=js"
export * from "./HomeIcon.vue?vue&type=script&lang=js"

import "./HomeIcon.vue?vue&type=style&index=0&id=670349a5&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-670349a5"

export default script